import React, { FC, ChangeEvent } from 'react';
import {
  FormControl,
  RadioGroup,
  Typography,
  Box,
  Skeleton,
} from '@mui/material';
import LanguageCard from './components/card.component';

type ICheckBoxContainer = {
  disabled: boolean;
  initialLoad: boolean;
  setLanguage: React.Dispatch<React.SetStateAction<string | undefined>>;
};

const LanguageSelector: FC<ICheckBoxContainer> = ({
  disabled,
  initialLoad,
  setLanguage,
}) => {
  const handleOnChange = ({ target }: ChangeEvent<HTMLInputElement>) => {
    setLanguage(target.value);
  };

  return !initialLoad ? (
    <FormControl
      id='language-selector-container'
      disabled={disabled}
      sx={{
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      <RadioGroup
        row
        aria-labelledby='form-control-label'
        name='language'
        defaultValue='English'
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          gap: '24px',
        }}
        onChange={handleOnChange}
      >
        {!disabled && (
          <Typography
            id='language-selector-language-selector'
            variant='subtitle2'
            sx={{
              fontSize: '16px',
              color: 'secondary.contrastText',
              textAlign: 'center',
              fontWeight: '400',
              padding: '0 30px',
            }}
          >
            Please select your preferred interpreter language.
          </Typography>
        )}
        <Box
          id='language-card-selector-container'
          sx={{ display: 'flex', justifyContent: 'center', gap: '16px' }}
        >
          <LanguageCard disabled={disabled} label='English' value='English' />
          <LanguageCard disabled={disabled} label='Español' value='Spanish' />
        </Box>
      </RadioGroup>
    </FormControl>
  ) : (
    <Box
      id='language-skeleton-container'
      sx={{
        display: 'flex',
        gap: 3,
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Skeleton
        variant='rectangular'
        sx={{ borderRadius: '8px' }}
        width={132}
        height={120}
      />
      <Skeleton
        variant='rectangular'
        sx={{ borderRadius: '8px' }}
        width={132}
        height={120}
      />
    </Box>
  );
};

export default LanguageSelector;
